import { CHANNEL } from '@constants/channels';
import contactsHelper from './contacts';
import { convertToPluspointModel, checkUniqueContacts } from './bulk-contacts-upload';

export const validateBulkData = (data, locale, channelType) => {
    if (!data || data.length === 0) return null;
    const list = [];
    const isEmail = channelType === CHANNEL.EMAIL;

    data.forEach(element => {
        element = convertToPluspointModel(element);
        contactsHelper.checkPhoneNumbers(element, locale, 'phoneNumber');
        contactsHelper.checkEmails(element, 'email');
        list.push(element);
    });

    const filteredEmptyValues = isEmail ? list.filter(item => item.email) : list.filter(item => item.phoneNumber);

    return checkUniqueContacts(filteredEmptyValues, isEmail ? 'email' : 'phoneNumber');
};
